/**
 * The angularjs states related to the module UserPreferencesModule
 */
userPreferencesStates.$inject = ['$stateProvider'];
export function userPreferencesStates($stateProvider) {
  $stateProvider
    // Not used anymore, there is a redirection to `auth.alcmeon.fuse.preferences.account`.
    .state('auth.alcmeon.preferences', {
      url: '/preferences',
      abstract: true,
      views: {
        'sub-nav@auth': {
          template: require('src/ajs-app/components/core/subnav/navigation.preferences.html'),
          controller: 'NavigationPreferencesController',
        },
      },
    })

    .state('auth.alcmeon.fuse.preferences', {
      abstract: true,
      url: '/preferences',
      views: {
        'sub-nav@auth': {
          template: require('src/ajs-app/components/core/subnav/navigation.preferences.html'),
          controller: 'NavigationPreferencesController',
        },
      },
    })

    .state('auth.alcmeon.fuse.preferences.account', {
      url: '/account',
      views: {
        'container@auth': {
          template: `<angular-user-preferences-account></angular-user-preferences-account>`,
        },
      },
    })

    .state('auth.alcmeon.fuse.preferences.status-check', {
      url: '/status',
      views: {
        'container@auth': {
          template: `<angular-user-preferences-access-check></angular-user-preferences-access-check>`,
        },
      },
    })

    .state('auth.alcmeon.fuse.preferences.password', {
      url: '/password',
      views: {
        'container@auth': {
          template:
            '<angular-user-preferences-password-change [logged-user]="loggedUser" class="preferences"></angular-user-preferences-password-change>',
          controller: [
            '$scope',
            'loggedUser',
            function ($scope, loggedUser) {
              $scope.loggedUser = loggedUser; // TODO get from AlcmeonContextService.self
            },
          ],
        },
      },
    })

    .state('auth.alcmeon.fuse.preferences.notifications', {
      url: '/notifications',
      views: {
        'container@auth': {
          template: `<angular-user-preferences-notifications></angular-user-preferences-notifications>`,
        },
      },
    });
}

